import _ from 'lodash'
import { USE_PRAGYA_HELP } from '../../../config/pragyaHelp.js'
import { getUserInfo, getUsers, getUser, saveUser, saveUserProfile, deleteUser,
  createUser, updatePassword, createStudentUserByEmail, getUserAdvisor, authenticateWebWidget, authenticateZendesk,
  doCsvUploadForUsers, launchSubscriptionCheckout, getStripeSubscriptionDetail, launchStripeSubscriptionSetup,
  launchStripeSubscriptionCreation, changeStripeSubscription, cancelOrReactivateStripeSubscription,
  postSaveDataOptOut, updateDirectChannelPeerMap, getTourElements, getTourUserStatus,
  putUpdateTourUserStatus, getUserSubscriptions, getUserPaymentMethods, putCreateUserPaymentMethod,
  putCreateUserSubscription, putCancelUserSubscription, getUserTransactions, updateUserProfileResume,
  updateUserProfileResumeAsPrimary, getConnectionInfo, updateUserNewEmail, deleteUserProfileResume, deleteSubscription, updateUserContactInfo } from '../api'

export const loadUserInfo = ({ state, commit }, token) => {
  return getUserInfo(token).then((res) => {
    if (res) {
      let role = res.roles[0].role
      localStorage.setItem('userrole', role)
      localStorage.setItem('userid', res.uuid)
      localStorage.setItem('userFullName', res.firstName + ' ' + res.lastName)
      localStorage.setItem('userobj', JSON.stringify(res))
      localStorage.setItem('institutionId', res.institutionId)
      commit('LOAD_USER_NAME', res.firstName + ' ' + res.lastName)
      commit('LOAD_USER_ROLE', role)
      commit('LOAD_USER_OBJECT', res)
      commit('LOAD_PERMISSION', res.permission)
    }
    return res
  })
}

export const loadPermission = ({ state, commit }) => {
  let userObj = JSON.parse(localStorage.getItem('userobj'))
  if (userObj) {
    commit('LOAD_PERMISSION', userObj.permission)
    return userObj.permission
  }
}

export const loadUsers = ({ state, commit }, {parentSpaceId, page, count, role, name}) => {
  return getUsers(parentSpaceId, page, count, role, name).then(res => {
    commit('LOAD_USERS', res)
    return res
  })
}

export const loadUserAdvisor = ({ state, commit }, uuid) => {
  return getUserAdvisor(uuid).then(res => {
    commit('LOAD_USER_ADVISOR', res)
    return res
  })
}

export const loadUser = ({ state, commit }, uuid) => {
  return getUser(uuid).then(res => {
    commit('LOAD_USER', res)
    return res
  })
}

export const loadSaveUser = ({ state, commit }, {uuid, user}) => {
  return saveUser(uuid, user).then(res => {
    return res
  })
}

export const loadSaveDataOptOut = ({ state, commit }, formData) => {
  return postSaveDataOptOut(formData).then(res => {
    return res
  })
}

export const loadCreateUser = ({ state, commit }, {parentSpaceId, user}) => {
  return createUser(parentSpaceId, user).then(res => {
    return res
  })
}

export const loadUpdateUserContactInfo = ({ state, commit }, contactInfo) => {
  return updateUserContactInfo(contactInfo).then(res => {
    if (!res) {
      return res
    }
    let current = JSON.parse(localStorage.getItem('userobj') || '{}')
    let updated = Object.assign({}, current, res)
    if (current.password && !res.password) {
      updated.password = current.password
    }
    localStorage.setItem('userobj', JSON.stringify(updated))
    commit('LOAD_USER_OBJECT', updated)
    return updated
  })
}

export const loadUpdatePassword = ({ state, commit }, {data}) => {
  return updatePassword(data).then(res => {
    return res
  })
}

export const loadCreateUserByEmail = ({ state, commit }, {parentSpaceId, emails}) => {
  return createStudentUserByEmail(parentSpaceId, emails).then(res => {
    return res
  })
}

export const loadDeleteUser = ({ state, commit }, uuid) => {
  return deleteUser(uuid).then(res => {
    return res
  })
}
export const updateUserEmail = ({ state, commit }, {oldEmail, newEmail}) => {
  return updateUserNewEmail(oldEmail, newEmail).then(res => {
    return res
  })
}
export const loadUserCareerGoal = ({ state, commit }) => {
  let uObj = JSON.parse(localStorage.getItem('userobj'))
  let careerGoal = uObj.careerGoal
  if (careerGoal) {
    commit('LOAD_USER_CAREER_GOAL', uObj.careerGoal)
  }
  return careerGoal
}

export const loadUserPreferences = ({ state, commit }) => {
  let uObj = JSON.parse(localStorage.getItem('userobj'))
  commit('LOAD_USER_PREFERENCES', uObj.userPreferences)
  return uObj.userPreferences
}


export const loadSaveUserProfile= ({ state, commit }, {userProfile}) => {
  var uObj = JSON.parse(localStorage.getItem('userobj'))
  let userId = uObj.uuid
  uObj.userProfile = userProfile
  saveUserProfile(userId, uObj).then(res => {
    localStorage.setItem('userobj', JSON.stringify(res))
    commit('LOAD_USER_CAREER_GOAL', res.careerGoal)
    commit('LOAD_USER_PREFERENCES', res.userPreferences)
    return res
  })
}

export const loadSaveProfileCareer = ({ state, commit }, {careerGoal, careerGoalPragyaSoc}) => {
  var uObj = JSON.parse(localStorage.getItem('userobj'))
  let userId = uObj.uuid
  uObj.careerGoal = careerGoal
  uObj.careerGoalPragyaSoc = careerGoalPragyaSoc
  saveUserProfile(userId, uObj).then(res => {
    localStorage.setItem('userobj', JSON.stringify(res))
    commit('LOAD_USER_CAREER_GOAL', res.careerGoal)
    commit('LOAD_USER_PREFERENCES', res.userPreferences)
    return res
  })
}

export const loadSaveProfilePopup = ({ state, commit }, {isDoNotOpenProfilePopup}) => {
  var uObj = JSON.parse(localStorage.getItem('userobj'))
  let userId = uObj.uuid
  uObj.userPreferences.doNotOpenProfilePopup = isDoNotOpenProfilePopup
  saveUserProfile(userId, uObj).then(res => {
    localStorage.setItem('userobj', JSON.stringify(res))
    commit('LOAD_USER_CAREER_GOAL', res.careerGoal)
    commit('LOAD_USER_PREFERENCES', res.userPreferences)
    return res
  })
}

export const loadSaveProfileTour = ({ state, commit }, {isDoNotOpenGuide}) => {
  var uObj = JSON.parse(localStorage.getItem('userobj'))
  let userId = uObj.uuid
  uObj.userPreferences.doNotOpenGuide = isDoNotOpenGuide
  saveUserProfile(userId, uObj).then(res => {
    localStorage.setItem('userobj', JSON.stringify(res))
    commit('LOAD_USER_CAREER_GOAL', res.careerGoal)
    commit('LOAD_USER_PREFERENCES', res.userPreferences)
    return res
  })
}

export const loadAuthenticateWebWidget = ({ state, commit }, uuid) => {
  if (USE_PRAGYA_HELP) {
    return Promise.resolve()
  }
  if (_.isEmpty(state.zendeskWidgetToken)) {
    return authenticateWebWidget().then(res => {
      commit('LOAD_ZENDESK_WIDGET_TOKEN', res.token)
      commit('LOAD_ZENDESK_WIDGET_ID', res.widgetId)
      commit('LOAD_ZENDESK_WIDGET_THEME', res.theme)
      var script1 = document.createElement('script')
      script1.type = 'text/javascript'
      script1.id = 'ze-snippet'
      script1.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + res.widgetId
      document.body.appendChild(script1)

      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.text = "window.zESettings = {authenticate: { jwt: '" + res.token + "' }, webWidget: { zIndex:  990,  color: { theme: '"+ res.theme + "' }, position: {horizontal: 'right', vertical:'top'}, offset: {vertical:'54px', horizontal: '40px'}}};"
      document.body.appendChild(script)
      return res
    })
  } else {
    var script1 = document.createElement('script')
    script1.type = 'text/javascript'
    script1.id = 'ze-snippet'
    script1.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + state.zendeskWidgetId
    document.body.appendChild(script1)

    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.text = "window.zESettings = {authenticate: { jwt: '" + state.zendeskWidgetToken + "' }, webWidget: { zIndex:  990, color: { theme: '"+ state.zendeskWidgetTheme + "' } position: {horizontal: 'right', vertical:'top'}, offset: {vertical:'54px', horizontal: '40px'}}};"
    document.body.appendChild(script)
  }
}

export const loadZendeskJWT = ({ state, commit }, redirect) => {
  return authenticateZendesk(redirect).then(res => {
    return res
  })
}

export const uploadUserCsvFile = ({ state, commit }, {institutionId, createdByUuid, fileData}) => {
  console.log('in uploadUserCsvFile', institutionId, createdByUuid, fileData)
  return doCsvUploadForUsers(institutionId, createdByUuid, fileData).then(res => {
    return res
  })
}

export const loadSubscriptionCheckout = ({ state, commit }, planType) => {
  return launchSubscriptionCheckout(planType)
}

export const loadStripeSubscriptionSetup = ({ state, commit }, planType) => {
  return launchStripeSubscriptionSetup(planType)
}

export const loadStripeSubscriptionCreation = ({ state, commit }, { planType, sessionId }) => {
  return launchStripeSubscriptionCreation(planType, sessionId)
}

export const loadStripeSubscriptionDetail = ({ state, commit }, data) => {
  return getStripeSubscriptionDetail(data)
}

export const loadChangeStripeSubscription = ({ state, commit }, planType) => {
  return changeStripeSubscription(planType)
}

export const loadCancelOrReactivateStripeSubscription = ({ state, commit }, cancelOrReactivate) => {
  return cancelOrReactivateStripeSubscription(cancelOrReactivate)
}

export const loadCurrentPage = ({ state, commit }, newCurrentPage) => {
  console.log('loadCurrent Page got called: ', newCurrentPage)
  commit('LOAD_CURRENT_PAGE', newCurrentPage)
}

export const loadTourElements = ({ state, commit }) => {
  return getTourElements()
}

export const loadTourUserStatus = ({ state, commit }) => {
  return getTourUserStatus()
}

export const loadForceResetTourElements = ({ state, commit }, newForceResetTourElements) => {
  commit('LOAD_FORCE_RESET_TOUR_ELEMENTS', newForceResetTourElements)
}

export const loadUpdateTourUserStatus = ({ state, commit }, tourStatus) => {
  return putUpdateTourUserStatus(tourStatus)
}

export const loadUserSubscriptions = ({ state, commit }) => {
  return getUserSubscriptions()
}

export const loadCreateUserSubscription = ({ state, commit }, userSubscriptionObj) => {
  return putCreateUserSubscription(userSubscriptionObj)
}
export const loadCancelUserSubscription = ({ state, commit }, subscriptionUuid) => {
  return putCancelUserSubscription(subscriptionUuid)
}

export const loadUserPaymentMethods = ({ state, commit }) => {
  return getUserPaymentMethods()
}

export const loadCreateUserPaymentMethod = ({ state, commit }, paymentMethodObj) => {
  return putCreateUserPaymentMethod(paymentMethodObj)
}

export const loadUserTransactions = ({ state, commit }) => {
  return getUserTransactions()
}

export const loadUpdateProfileResume = ({ state, commit }, {uuid, resume}) => {
  return updateUserProfileResume(uuid, resume)
}

export const loadUpdateProfileResumeAsPrimary = ({ state, commit }, {uuid, id}) => {
  return updateUserProfileResumeAsPrimary(uuid, id)
}

export const loadDeleteProfileResume = ({ state, commit }, {uuid, id}) => {
  return deleteUserProfileResume(uuid, id)
}

export const loadDeleteSubscription = ({ state, commit }, transactionObj) => {
  return deleteSubscription(transactionObj)
}

export const getAIServerConnectionInfo = ({ state, commit }) => {
  return getConnectionInfo()
}




// WEBPACK FOOTER //
// ./src/app/user/vuex/actions.js